module.exports = __webpack_public_path__ + "1e9f594ebbf101e7260636a7d9352454.svg";